/**
 * @fileoverview added by tsickle
 * Generated from: formio.config.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { Injectable } from '@angular/core';
import * as ɵngcc0 from '@angular/core';
var FormioAppConfig = /** @class */ (function () {
    function FormioAppConfig() {
        this.appUrl = '';
        this.apiUrl = '';
    }
FormioAppConfig.ɵfac = function FormioAppConfig_Factory(t) { return new (t || FormioAppConfig)(); };
FormioAppConfig.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: FormioAppConfig, factory: function (t) { return FormioAppConfig.ɵfac(t); } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormioAppConfig, [{
        type: Injectable
    }], function () { return []; }, null); })();
    return FormioAppConfig;
}());
export { FormioAppConfig };
if (false) {
    /** @type {?} */
    FormioAppConfig.prototype.appUrl;
    /** @type {?} */
    FormioAppConfig.prototype.apiUrl;
    /** @type {?} */
    FormioAppConfig.prototype.icons;
    /** @type {?} */
    FormioAppConfig.prototype.formOnly;
}

